"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelematicsTenderd = exports.DefaultEndPoint = exports.getFuelConsumption = exports.getFuelConsumptionV2 = exports.distance = exports.getDumpTruckTrips = exports.fetchDumpTruckTrips = exports.getProductivity = exports.fetchProductivity = exports.fetchFuelPrediction = exports.fetchEmissionPrediction = exports.fetchFuelConsumed = exports.BackendError = exports.MICROSERVICE_URL = void 0;
const Telematics_1 = require("./Telematics");
const schema_1 = require("@tenderd/schema");
const node_fetch_1 = __importDefault(require("node-fetch"));
const date_fns_1 = require("date-fns");
exports.MICROSERVICE_URL = "https://microservices-6b4zmveoia-uc.a.run.app";
class BackendError extends Error {
    constructor(message, status) {
        super(message + ' Code: ' + status);
        this.message = message;
        this.status = status;
    }
}
exports.BackendError = BackendError;
const fetchFuelConsumed = (requestBody) => {
    let body = {
        data: requestBody.data
    };
    if (requestBody.trip) {
        body.trip = requestBody.trip;
    }
    let params = {
        method: 'POST', body: JSON.stringify(body)
    };
    params.headers = Object.assign(Object.assign({}, (params.headers || {})), { 'Content-Type': 'application/json' });
    return (0, node_fetch_1.default)(`${exports.MICROSERVICE_URL}/get_fuel_consumed`, params).then((res) => {
        if (res.status >= 400) {
            return res.text().then((v) => {
                console.log(v);
            });
        }
        return res.json().then(body => {
            return body;
        });
    });
};
exports.fetchFuelConsumed = fetchFuelConsumed;
const fetchEmissionPrediction = (requestBody, urlOverride) => {
    let params = {
        method: 'POST', body: JSON.stringify(requestBody)
    };
    params.headers = Object.assign(Object.assign({}, (params.headers || {})), { 'Content-Type': 'application/json' });
    return (0, node_fetch_1.default)(`${urlOverride || exports.MICROSERVICE_URL}/emission_prediction_v4`, params).then((res) => {
        if (res.status >= 400) {
            return res.text().then((v) => {
                throw new Error(v);
            });
        }
        return res.json().then(body => {
            return body;
        });
    });
};
exports.fetchEmissionPrediction = fetchEmissionPrediction;
const fetchFuelPrediction = (requestBody, urlOverride) => {
    let params = {
        method: 'POST', body: JSON.stringify(requestBody)
    };
    params.headers = Object.assign(Object.assign({}, (params.headers || {})), { 'Content-Type': 'application/json' });
    return (0, node_fetch_1.default)(`${urlOverride || exports.MICROSERVICE_URL}/fuel_prediction`, params).then((res) => {
        if (res.status >= 400) {
            return res.text().then((v) => {
                throw new Error(v);
            });
        }
        return res.json().then(body => {
            return body;
        });
    });
};
exports.fetchFuelPrediction = fetchFuelPrediction;
const fetchProductivity = (requestBody, urlOverride) => __awaiter(void 0, void 0, void 0, function* () {
    let params = {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json',
        }
    };
    const res = yield (0, node_fetch_1.default)(`${urlOverride || exports.MICROSERVICE_URL}/productivity`, params);
    if (res.status >= 400) {
        return res.text().then((v) => {
            console.log(v);
        });
    }
    const body = yield res.json();
    return body;
});
exports.fetchProductivity = fetchProductivity;
const getProductivity = (data, metric, equipment_type, capacity, urlOverride) => __awaiter(void 0, void 0, void 0, function* () {
    let returnData = {
        data: [],
        total: 0,
        average_loading_time: 0,
        average_unloading_time: 0,
        threshold: 0
    };
    if (!data.length)
        return returnData;
    const fetchProductivityMicroServiceData = yield (0, exports.fetchProductivity)({ data, metric, equipment_type, capacity }, urlOverride);
    returnData.data = (fetchProductivityMicroServiceData === null || fetchProductivityMicroServiceData === void 0 ? void 0 : fetchProductivityMicroServiceData.data) || [];
    returnData.total = (fetchProductivityMicroServiceData === null || fetchProductivityMicroServiceData === void 0 ? void 0 : fetchProductivityMicroServiceData.total) || 0;
    returnData.average_loading_time = (fetchProductivityMicroServiceData === null || fetchProductivityMicroServiceData === void 0 ? void 0 : fetchProductivityMicroServiceData.average_loading_time) || 0;
    returnData.average_unloading_time = (fetchProductivityMicroServiceData === null || fetchProductivityMicroServiceData === void 0 ? void 0 : fetchProductivityMicroServiceData.average_unloading_time) || 0;
    returnData.threshold = (fetchProductivityMicroServiceData === null || fetchProductivityMicroServiceData === void 0 ? void 0 : fetchProductivityMicroServiceData.threshold) || 0;
    return returnData;
});
exports.getProductivity = getProductivity;
const fetchDumpTruckTrips = (requestBody) => {
    let params = {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return (0, node_fetch_1.default)(`${exports.MICROSERVICE_URL}/trips`, params).then((res) => {
        if (res.status >= 400) {
            return res.text().then((v) => {
                console.log(v);
            });
        }
        return res.json().then(body => {
            return body;
        });
    });
};
exports.fetchDumpTruckTrips = fetchDumpTruckTrips;
const getDumpTruckTrips = (data, geofences, capacity) => __awaiter(void 0, void 0, void 0, function* () {
    let returnData = {
        data: [],
        total: 0
    };
    if (!data.length)
        return returnData;
    const fetchDumpTruckTripMicroServiceData = yield (0, exports.fetchDumpTruckTrips)({ data, geofences, capacity });
    returnData.data = (fetchDumpTruckTripMicroServiceData === null || fetchDumpTruckTripMicroServiceData === void 0 ? void 0 : fetchDumpTruckTripMicroServiceData.data) || [];
    returnData.total = (fetchDumpTruckTripMicroServiceData === null || fetchDumpTruckTripMicroServiceData === void 0 ? void 0 : fetchDumpTruckTripMicroServiceData.total) || 0;
    return returnData;
});
exports.getDumpTruckTrips = getDumpTruckTrips;
// distance calculation:
// https://github.com/traccar/traccar/blob/master/src/main/java/org/traccar/helper/DistanceCalculator.java
// meters
const EQUATORIAL_EARTH_RADIUS = 6378.137;
const DEG_TO_RAD = Math.PI / 180;
const distance = (lat1, lon1, lat2, lon2) => {
    const dlong = (lon2 - lon1) * DEG_TO_RAD;
    const dlat = (lat2 - lat1) * DEG_TO_RAD;
    const a = Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(lat1 * DEG_TO_RAD) *
            Math.cos(lat2 * DEG_TO_RAD) *
            Math.pow(Math.sin(dlong / 2), 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = EQUATORIAL_EARTH_RADIUS * c;
    return d * 1000;
};
exports.distance = distance;
const getFuelConsumptionV2 = (device, data, start, end) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const tankCapacity = device.tank_capacity || 0;
    let returnData = {
        fuelUsed: 0,
        fuelEvents: [],
        fuelConsumed: 0
    };
    const rawData = data
        //@ts-ignore
        .filter((d) => d.ignition_status && d.fuel_level)
        .map((d) => {
        //@ts-ignore
        return { datetime: new Date(d.datetime), fuel_level: d.fuel_level };
    });
    if (!rawData.length)
        return returnData;
    let dataFuel = { data: rawData };
    let tripFlag = false;
    if (start && end) {
        //@ts-ignore
        dataFuel = Object.assign(Object.assign({}, dataFuel), { trip: { start: start, end: end } });
        tripFlag = true;
    }
    const fetchFuel = yield (0, exports.fetchFuelConsumed)(dataFuel);
    returnData.fuelEvents = (fetchFuel === null || fetchFuel === void 0 ? void 0 : fetchFuel.fuel_events) || [];
    if (tripFlag) {
        returnData.fuelConsumed = fetchFuel.fuel_consumed.trip * tankCapacity / 100 || 0;
        returnData.fuelUsed = fetchFuel.fuel_consumed.trip || 0;
    }
    else {
        returnData.fuelUsed = ((_a = fetchFuel === null || fetchFuel === void 0 ? void 0 : fetchFuel.fuel_consumed) === null || _a === void 0 ? void 0 : _a.total) || 0;
        returnData.fuelConsumed = (((_b = fetchFuel === null || fetchFuel === void 0 ? void 0 : fetchFuel.fuel_consumed) === null || _b === void 0 ? void 0 : _b.total) * tankCapacity) / 100 || 0;
    }
    return returnData;
});
exports.getFuelConsumptionV2 = getFuelConsumptionV2;
const getFuelConsumption = (device, data, speedThreshold = 5) => {
    // Fuel data jitters
    // Consider the most frequent fuel level in duration 15 minutes
    // A refuel event is identified by increase in fuel level more than 15%
    let consumedSum = 0;
    let refueledSum = 0;
    const tankCapacity = device.tank_capacity || 0;
    // most frequent value in 4 (used to be 15) minutes window
    const values = [];
    let mostFrequentMap = {};
    let start;
    //only calculate fuel events when machine is stationary (that is, ignition is ON and not moving; (that is, speed is less than 5)
    const filteredData = data.filter(
    //@ts-ignore
    (d) => d.fuel_level && d.ignition_status && d.speed < speedThreshold);
    filteredData.forEach((item) => {
        //@ts-ignore
        const fuelLevel = Math.round(item.fuel_level * 100) / 100;
        if (!start) {
            //@ts-ignore
            start = new Date(item.datetime);
            mostFrequentMap[fuelLevel] = 1;
            return;
        }
        //@ts-ignore
        if ((0, date_fns_1.isBefore)(new Date(item.datetime), (0, date_fns_1.addMinutes)(start, 15))) {
            if (!mostFrequentMap[fuelLevel]) {
                mostFrequentMap[fuelLevel] = 0;
            }
            mostFrequentMap[fuelLevel]++;
        }
        else {
            const max = Object.keys(mostFrequentMap).reduce((prev, current) => mostFrequentMap[prev] > mostFrequentMap[current]
                ? prev
                : current);
            values.push({
                level: Number(max),
                count: mostFrequentMap[Number(max)],
                start: start,
                //@ts-ignore
                //_id: item._id
            });
            // reset for next 
            //@ts-ignore
            start = new Date(item.datetime);
            mostFrequentMap = {};
            mostFrequentMap[fuelLevel] = 1;
        }
    });
    let lastData;
    const events = [];
    values.forEach((v) => {
        if (!lastData) {
            lastData = v;
            return;
        }
        const fuelLevelChange = (Number(v.level) || 0) - (Number(lastData.level) || 0);
        const percentageChange = fuelLevelChange / 100;
        const change = tankCapacity * percentageChange;
        if (v.level > lastData.level) {
            if (v.level - lastData.level < 25) {
                // outlier
                return;
            }
            else {
                // refuel
                refueledSum += change;
                if (v.level - lastData.level > 25) {
                    events.push({
                        date: lastData.start,
                        event: Telematics_1.FuelEventType.Refill,
                        fuel_percent_after: v.level > 100 ? 100 : Math.round(v.level),
                        fuel_percent_before: lastData.level > 100 ? 100 : lastData.level,
                        quantity: change,
                    });
                    lastData = v;
                }
            }
        }
        else {
            // consumption
            consumedSum += -1 * change;
            if (lastData.level - v.level > 30) {
                events.push({
                    date: lastData.start,
                    event: Telematics_1.FuelEventType.Theft,
                    fuel_percent_after: v.level > 100 ? 100 : Math.round(v.level),
                    fuel_percent_before: lastData.level > 100 ? 100 : lastData.level,
                    quantity: Math.abs(change),
                });
            }
            lastData = v;
        }
    });
    return {
        consumed: Number.isNaN(consumedSum) ? 0 : consumedSum,
        refueled: refueledSum,
        starting_fuel_level: values.length > 0 ? values[0].level : 0,
        ending_fuel_level: values.length > 0
            ? Math.round(values[values.length - 1].level)
            : 0,
        events,
    };
};
exports.getFuelConsumption = getFuelConsumption;
exports.DefaultEndPoint = 'https://api.tenderd.com';
class TelematicsTenderd {
    constructor(authServiceClient, geo = schema_1.Geo.UAE, endPoint = exports.DefaultEndPoint) {
        this.authServiceClient = authServiceClient;
        this.geo = geo;
        this.endPoint = endPoint;
    }
    getAllDevices() {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices`, {});
    }
    getDevices(ids) {
        const body = { ids };
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/get-by-ids`, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    }
    getDeviceById(id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${id}`, {
            method: 'GET',
        });
    }
    getDeviceHistory(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        let url = `${this.endPoint}/telematics/devices/${form.deviceId}/device-histories?start_date=${startDate}&end_date=${endDate}&geo=${this.geo}`;
        if (form.page) {
            url = `${url}&page=${form.page}`;
        }
        if (form.allData) {
            url = `${url}&allData=${form.allData}`;
        }
        if (form.projection) {
            url = `${url}&projection=${JSON.stringify(form.projection)}`;
        }
        return this.authServiceClient.fetchWithFirebaseToken(url, {
            method: 'GET',
        });
    }
    getDeviceHistoryPaginated(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        const queryparams = new URLSearchParams();
        queryparams.append("start_date", startDate);
        queryparams.append("end_date", endDate);
        queryparams.append("geo", this.geo);
        form.page && queryparams.append("page", form.page.toString());
        form.limit && queryparams.append("limit", form.limit.toString());
        form.allData && queryparams.append("allData", form.allData.toString());
        form.projection && queryparams.append("projection", JSON.stringify(form.projection));
        let url = `${this.endPoint}/telematics/devices/${form.deviceId}/histories?${queryparams.toString()}`;
        return this.authServiceClient.fetchWithFirebaseToken(url, {
            method: 'GET',
        });
    }
    getDeviceHistoryOptimized(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        const queryparams = new URLSearchParams();
        queryparams.append("start_date", startDate);
        queryparams.append("end_date", endDate);
        queryparams.append("geo", this.geo);
        form.projection && queryparams.append("projection", JSON.stringify(form.projection));
        let url = `${this.endPoint}/telematics/devices/${form.deviceId}/histories-optimized?${queryparams.toString()}`;
        return this.authServiceClient.fetchWithFirebaseToken(url, {
            method: 'GET',
        });
    }
    getDeviceHistoryByLimit(form) {
        let url = `${this.endPoint}/telematics/devices/${form.deviceId}/device-histories-by-limit?limit=${form.limit}`;
        return this.authServiceClient.fetchWithFirebaseToken(url, {
            method: 'GET',
        });
    }
    createDevice(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    status(ids) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/status`, {
            method: 'GET',
        });
    }
    getDevicesByDate(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices?start_date=${startDate}&end_date=${endDate}`, {
            method: 'GET'
        });
    }
    getViolations(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        const limit = form.limit ? form.limit : 50;
        const page = form.page ? form.page : 0;
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.deviceId}/violations?start_date=${startDate}&end_date=${endDate}&limit=${limit}&page=${page}&projectId=${form.projectId}`, {
            method: 'GET',
        });
    }
    getConfigurationDetails(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.id}/configuration`, {
            method: 'GET'
        });
    }
    getMachineDetailProductivity(deviceId, startDate, endDate) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${deviceId}/productivity?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`, {
            method: 'GET'
        });
    }
    sendCommand(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/send-command`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    updateConfig(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.id}/config`, {
            method: 'PUT',
            body: JSON.stringify({ config: form.config })
        });
    }
    updateViolationConfig(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.id}/violation-config`, {
            method: 'PUT',
            body: JSON.stringify({ violation_config: form.violation_config })
        });
    }
    getFuelData(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.deviceId}/device-histories-fuel-data?start_date=${form.start_date.toISOString()}&end_date=${form.end_date.toISOString()}`, {
            method: 'GET',
        });
    }
    getAnalytics(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/analytics?project_id=${form.project_id}&start_date=${form.start_date.toISOString()}&end_date=${form.end_date.toISOString()}`, {
            method: 'GET',
        });
    }
    getAnalyticsV2(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/v2/analytics?project_id=${form.project_id}&start_date=${form.start_date.toISOString()}&end_date=${form.end_date.toISOString()}`, {
            method: 'GET',
        });
    }
    addReportRequest(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/reports`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    getReportRequests(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/reports?project_id=${form.project_id}&page=${form.page}&limit=${form.limit}`, {
            method: 'GET'
        });
    }
    deleteGeneratedReport(id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/reports?id=${id}`, {
            method: 'DELETE'
        });
    }
    updateDeviceTypeConfig(form) {
        const { id } = form, rest = __rest(form, ["id"]);
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${id}/device-type-config`, {
            method: 'PUT',
            body: JSON.stringify(rest)
        });
    }
    updateDeviceCO2Emission(form) {
        const { id } = form, rest = __rest(form, ["id"]);
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${id}/co2`, {
            method: 'PUT',
            body: JSON.stringify(rest)
        });
    }
    untagDevice(deviceId) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${deviceId}/untag`, {
            method: 'PUT'
        });
    }
    updateImeiAndSim(form) {
        const { id } = form, rest = __rest(form, ["id"]);
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${id}/imei`, {
            method: 'PUT',
            body: JSON.stringify(rest)
        });
    }
    // to be called when telematics device is replaced
    updateDeviceType(form) {
        const { device_id } = form, rest = __rest(form, ["device_id"]);
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}/type`, {
            method: 'PUT',
            body: JSON.stringify(rest)
        });
    }
    // device meta data
    updateDeviceInfo(form) {
        const { device_id } = form, rest = __rest(form, ["device_id"]);
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}`, {
            method: 'PUT',
            body: JSON.stringify(rest)
        });
    }
    addCarTrackAccount(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/cartrack-accounts`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    getCarTrackAccounts(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/cartrack-accounts/?account_id=${form.account_id}`, {
            method: 'GET'
        });
    }
    addIButton(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/ibuttons`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    removeIButton(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/ibuttons/${form.id}`, {
            method: 'DELETE'
        });
    }
    updateIButtonByOperatorId(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/ibuttons/${form.ibutton}`, {
            method: 'PUT',
            body: JSON.stringify({ operator_ref: form.operator_ref })
        }); //
    }
    getIButton(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/ibuttons/${form.device_id}`, {
            method: 'GET'
        });
    }
    //
    getLastOperator(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/ibuttons/last-operator?machine_id=${form.machineId}&start_date=${startDate}&end_date=${endDate}`, {
            method: 'GET'
        });
    }
    getFuelEventsByIdAndRange(form) {
        const startDate = JSON.parse(JSON.stringify(form.startDate));
        const endDate = JSON.parse(JSON.stringify(form.endDate));
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${form.id}/fuel-events?start_date=${startDate}&end_date=${endDate}`, {
            method: 'GET'
        });
    }
    getReport(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/reports/sync?report_type=${form.formatType || 'csv'}`, {
            method: 'POST',
            body: JSON.stringify(form),
            headers: { responseType: 'blob' }
        });
    }
    getVesselEmissionsTimesheet(equipmentId, startDate, endDate) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/vessel-emissions/timesheet?equipmentId=${equipmentId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`, {
            method: 'GET',
        });
    }
    createShift(form) {
        const { device_id } = form;
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}/shift-settings`, {
            method: 'POST',
            body: JSON.stringify(form.shift_settings),
        });
    }
    updateShift(form) {
        const { device_id } = form;
        const shift_id = form.shift_settings._id;
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}/shift-settings/${shift_id}`, {
            method: 'PUT',
            body: JSON.stringify(form.shift_settings)
        });
    }
    deleteShift(device_id, shift_id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}/shift-settings/${shift_id}`, {
            method: 'DELETE'
        });
    }
    getShift(device_id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/devices/${device_id}/shift-settings`, {
            method: 'GET'
        });
    }
    getRFIDFuelEventsByDateRange(equipmentIds, startDate, endDate) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/fuel-history/RFID-fuelevents?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`, {
            method: 'POST',
            body: JSON.stringify({ equipmentIds: equipmentIds })
        });
    }
    getMetrics(accountId, equipmentId, equipmentType) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/productivity-utilisation-metric?equipmentId=${equipmentId || ''}&accountId=${accountId || ''}&equipmentType=${equipmentType || ''}`, {
            method: 'GET',
        });
    }
    getMetricsById(id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/productivity-utilisation-metric/${id}`, {
            method: 'GET',
        });
    }
    createMetrics(form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/productivity-utilisation-metric`, {
            method: 'POST',
            body: JSON.stringify(form),
        });
    }
    updateMetrics(id, form) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/productivity-utilisation-metric/${id}`, {
            method: 'PUT',
            body: JSON.stringify(form)
        });
    }
    deleteMetric(id) {
        return this.authServiceClient.fetchWithFirebaseToken(`${this.endPoint}/telematics/productivity-utilisation-metric/${id}`, {
            method: 'DELETE'
        });
    }
}
exports.TelematicsTenderd = TelematicsTenderd;
//# sourceMappingURL=TelematicsTenderd.js.map